export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export const paymentStatusFilterList = [
  { id: "New", name: "New" },
  { id: "Cancelled", name: "Cancelled" },
  { id: "Paid", name: "Paid" },
  { id: "Failed", name: "Failed" },
  { id: "Expired", name: "Expired" },
  { id: "Posted", name: "Posted" },
];
